import { apiClient } from './client';
import type { User } from '@/types/models';

interface UserListResponse {
  items: User[];
  total: number;
}

export interface StaffRegisterCustomerData {
  full_name: string;
  phone: string;
  password: string;
  atomi_id: number;
  email?: string;
}

export interface ConfirmCustomerData {
  password: string;
  full_name?: string;
  phone?: string;
  email?: string;
}

export interface ConfirmCustomerResponse {
  user: User;
  magic_link_token: string;
}

export const clientsApi = {
  // GET /api/v1/registration/customers — list customers (staff-only)
  getClients: async (params?: Record<string, any>): Promise<UserListResponse> => {
    const response = await apiClient.get<UserListResponse>('/v1/registration/customers', {
      params,
    });
    return response.data;
  },

  // GET /api/v1/registration/customer/by-atomi-id/{id} — search by Atomi ID
  searchByAtomiId: async (atomiId: number): Promise<User> => {
    const response = await apiClient.get<User>(`/v1/registration/customer/by-atomi-id/${atomiId}`);
    return response.data;
  },

  // POST /api/v1/registration/customer/by-staff — register client
  registerClient: async (data: StaffRegisterCustomerData): Promise<User> => {
    const response = await apiClient.post<User>('/v1/registration/customer/by-staff', data);
    return response.data;
  },

  // POST /api/v1/registration/customer/{userId}/confirm — confirm pending client
  confirmClient: async (userId: number, data: ConfirmCustomerData): Promise<ConfirmCustomerResponse> => {
    const response = await apiClient.post<ConfirmCustomerResponse>(
      `/v1/registration/customer/${userId}/confirm`,
      data,
    );
    return response.data;
  },
};
